export default __webpack_public_path__ + "static/media/penink01.d2d2c1ec.png";